<h1 mat-dialog-title i18n>Bike Transfer</h1>

<form [formGroup]="formInputs">
	<div class="section-details">
		<label class="col-4" i18n>Bike Id</label>
		<input class="col-4" type="text" disabled value="{{dialogData['bike']['bikeUuid']}}"/>
	</div>

	<div class="section-details">
		<label class="col-4" i18n>Bike Serial Number</label>
		<input class="col-4" type="text" disabled value="{{dialogData['bike']['serialNumber']}}"/>
	</div>

	<mat-form-field appearance="standard" class="w-100">
		<mat-label i18n>New Owner's Email Address</mat-label>
		<input matInput type="text" placeholder="email" i18n-placeholder formControlName="email" />
	</mat-form-field>
</form>

<div class="row mr-4">
	<div class="col-12 text-right mb-4 mt-2">
		<button
			type="submit"
			mat-flat-button
			color="primary"
			i18n
			(click)="close()"
			class="float-right col-12 col-sm-auto mb-2 mb-sm-0"
		>Close</button>

		<button
			type="button"
			mat-flat-button
			color="warn"
			i18n
			(click)="beginTransfer()"
			title="Close"
			i18n-title
			class="float-right mr-sm-2 col-12 col-sm-auto reset-button"
		>Begin Transfer</button>
	</div>
</div>
